import client1 from "../assets/images/clients/client1.png";
import client2 from "../assets/images/clients/client2.png";
import client3 from "../assets/images/clients/client3.png";

const reviews = [
  {
    name: "Mati Mustafi",
    descriptionEN: `Kudos to the team for their work. 
      They are true professionals in mobile applications.
      Their qualities:
      • Seriousness 
      • Reactivity 
      • Quality deliverables
      • Constant support.
      I highly recommend them, Thanks to Anas and Rachid for their work.`,
    descriptionFR: `Bravo à l'équipe pour leur travail. 
      Ce sont de vrais professionnels des applications mobiles.
      Leurs qualités :
      • Le sérieux 
      • La réactivité 
      • Livrable de qualité
      • Accompagnement constant.
      Je les recommande fortement, Merci à Anas et Rachid pour leur travail.`,
    src: client3,
    roleEN: "Ramsys Maroc",
    roleFR: "Ramsys Maroc",
  },
  {
    name: "Hiba",
    descriptionEN: `I worked with BIGWALL TECHNOLOGY on a stock management application, I appreciated the attention to detail and their great concern for my issues. They demonstrated availability and reliability throughout the project, I am very satisfied.`,
    descriptionFR: `J'ai travaillé avec BIGWALL TECHNOLOGY dans le cadre d'une application de gestion de stock, j'ai apprécié le souci du détail et leur grande attention envers ma problématique. Ils ont fait preuve de disponibilité et de fiabilité tout au long du projet, je suis très satisfaite.`,
    src: client1,
    roleEN: "Founder of H kids",
    roleFR: "Fondatrice de H kids",
  },
  {
    name: "Hôtel & Ryads Barrière Le Naoura",
    descriptionEN: `A professional team that listens. I loved working with them, and it won't be the last time.`,
    descriptionFR: `Une équipe professionnelle et à l'écoute. J'ai adoré travailler avec eux, et ça ne sera pas la dernière fois.`,
    src: client2,
    roleEN: "Hotel",
    roleFR: "Hôtel",
  },
  {
    name: "Karim El Mansouri",
    descriptionEN: `Exceptional service! BIGWALL TECHNOLOGY transformed our e-commerce platform with innovative solutions. Their team was always available to answer our questions and implemented changes quickly. The results exceeded our expectations.`,
    descriptionFR: `Service exceptionnel ! BIGWALL TECHNOLOGY a transformé notre plateforme e-commerce avec des solutions innovantes. Leur équipe était toujours disponible pour répondre à nos questions et a mis en œuvre les changements rapidement. Les résultats ont dépassé nos attentes.`,
    src: client3,
    roleEN: "CEO, MarocShop",
    roleFR: "PDG, MarocShop",
  },
  {
    name: "Amina Belhaj",
    descriptionEN: `Working with BIGWALL TECHNOLOGY was a game-changer for our startup. Their technical expertise and strategic advice helped us launch our app ahead of schedule. The team is professional, creative, and truly cares about client success.`,
    descriptionFR: `Travailler avec BIGWALL TECHNOLOGY a été un tournant pour notre startup. Leur expertise technique et leurs conseils stratégiques nous ont aidés à lancer notre application avant la date prévue. L'équipe est professionnelle, créative et se soucie vraiment de la réussite du client.`,
    src: client2,
    roleEN: "CTO, TechStart",
    roleFR: "Directrice Technique, TechStart",
  },
  {
    name: "Youssef Khadiri",
    descriptionEN: `The mobile app developed by BIGWALL TECHNOLOGY has significantly improved our customer engagement. Their attention to user experience and seamless integration with our existing systems was impressive. Highly recommended for any digital transformation project.`,
    descriptionFR: `L'application mobile développée par BIGWALL TECHNOLOGY a considérablement amélioré l'engagement de nos clients. Leur attention à l'expérience utilisateur et l'intégration transparente avec nos systèmes existants étaient impressionnantes. Fortement recommandé pour tout projet de transformation numérique.`,
    src: client1, // You can use existing images or add new ones
    roleEN: "Digital Manager, BankD",
    roleFR: "Responsable Digital, BankD",
  }
];

export default reviews;